module.exports = __webpack_public_path__ + "img/welcome.02a4f2ab.png";